module["exports"] = [];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/name/suffix.js
// module id = 1580
// module chunks = 0